export interface TypesPortalsOption {
  value: number;
  label: string;
}

export const TypesPortalsOptions: TypesPortalsOption[] = [
  {
    value: 1,
    label: 'Portal',
  },
  {
    value: 2,
    label: 'CRC',
  },
];
